import { Button, Dialog, PlainButton } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import React, { ReactNode } from "react";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { WorkspaceFeature } from "@web-src/modules/workspace/hooks/useWorkspaceFeatureCardData/useWorkspaceFeatureCardData";
import { HELP_CENTER_URL } from "@jugl-web/utils/consts";
import { ReactComponent as CloseIcon } from "./assets/close.svg";
import rocketAnimation from "./assets/rocket-animation.json";
import backgroundimage from "./assets/background.png";

export const PaidFeatureDialog: React.FC<{
  isOpen: boolean;
  feature?: WorkspaceFeature;
  onRequestClose: () => void;
}> = ({ isOpen, feature, onRequestClose }) => {
  const { t } = useTranslations();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onRequestClose}
      className="flex w-[600px] flex-col items-center justify-center px-20 pt-6 pb-14 text-center"
    >
      <PlainButton
        className="absolute right-5 top-5 flex h-8 w-8 items-center justify-center"
        onClick={onRequestClose}
      >
        <CloseIcon />
      </PlainButton>
      <div className="relative">
        <img
          src={backgroundimage}
          alt=""
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        />
        <Lottie
          options={{ animationData: rocketAnimation }}
          width={357}
          height={239}
        />
      </div>
      <span className="text-dark font-secondary mt-6 text-[22px] font-semibold leading-[33px]">
        {t(
          {
            id: "workspace-features-page.unlock-feature-title",
            defaultMessage:
              "Unlock {featureName} power and dominate your daily workflow",
          },
          { featureName: feature?.title }
        )}
      </span>
      <span className="text-dark-800 font-secondary mt-2 text-sm leading-[21px]">
        {t(
          {
            id: "workspace-features-page.unlock-feature-description",
            defaultMessage:
              "<highlightedText>Top teams use {featureName}</highlightedText> feature to move faster and win more. Want in? We’ll help you get started.",
          },
          {
            featureName: feature?.title,
            highlightedText: (text: ReactNode) => (
              <span className="text-primary-800 font-medium">{text}</span>
            ),
          }
        )}
      </span>
      <span className="font-secondary text-primary-800 mt-4 w-[85%] text-sm leading-[21px]">
        {t(
          {
            id: "workspace-features-page.ai-agents-feature-instruction",
            defaultMessage:
              "To enable this module, reach out to our support team or send us an email at {email}",
          },
          {
            email: (
              <a
                className="text-inherit underline"
                href="mailto:support@jugl.com"
              >
                support@jugl.com
              </a>
            ),
          }
        )}{" "}
        🙌
      </span>
      <Button
        className="mt-10 h-10 w-[200px]"
        onClick={() => {
          window.open(HELP_CENTER_URL, "_blank");
          onRequestClose();
        }}
      >
        {t({
          id: "workspace-features-page.contact-support",
          defaultMessage: "Contact Support",
        })}
      </Button>
    </Dialog>
  );
};
